import * as React from "react";

import { cn } from "@/app/lib/utils";

type InputSize = "sm" | "md" | "lg";
interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
   size?: InputSize;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(
   ({ className, type, size = "md", ...props }, ref) => {
      const sizeClasses = {
         sm: "h-7 text-sm md:text-xs px-2",
         md: "h-9 text-base md:text-sm px-3",
         lg: "h-11 text-lg md:text-base px-4"
      };
      return (
         <input
            type={type}
            className={cn(
               "flex w-full rounded-xl border border-input bg-transparent py-1 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
               sizeClasses[size],
               className
            )}
            ref={ref}
            {...props}
         />
      );
   }
);
Input.displayName = "Input";

export { Input };
